import { render, staticRenderFns } from "./AlertRuleStrategyType.global.vue?vue&type=template&id=e936cb84&lang=pug&"
import script from "./AlertRuleStrategyType.global.vue?vue&type=script&lang=ts&"
export * from "./AlertRuleStrategyType.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports